import {useEffect} from 'react';
import {useParams} from 'react-router-dom';

import {getClientDefaultTimeZone} from 'shared/lib/datetime';

export const useOAuthFinish = () => {
    const {provider} = useParams<{provider: string}>();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const deviceId = urlParams.get('device_id');
        const timezone = getClientDefaultTimeZone();

        if (window.opener) {
            window.opener.postMessage(
                {type: 'OAUTH_SUCCESS', provider, code, state, timezone, device_id: deviceId},
                window.location.origin,
            );
            window.close();
        }
    }, [provider]);
};

export default useOAuthFinish;
